// App entry. Mounts <App/>, wires self-hosted Geist fonts, design tokens, theme.
// The service worker is registered by vite-plugin-pwa (scope hard-locked to
// /feedback/, AC-B-018); SW is disabled in dev and active on the built preview.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/geist/400.css';
import '@fontsource/geist/500.css';
import '@fontsource/geist/600.css';
import '@fontsource/geist-mono/400.css';
import './styles/app.css';
import { initTheme } from './lib/theme';
import { App } from './App';

initTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
